import { Component, OnInit, SimpleChanges, OnChanges, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from 'src/app/_services/dispo/order.service';
import { CustomerBranchService } from 'src/app/_services/dispo/customer-branch.service';
import { AbstractControl, FormControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TeamBaseService } from 'src/app/_services/dispo/team-base';
import { prepareEventListenerParameters } from '@angular/compiler/src/render3/view/template';

@Component({
  selector: 'app-team-base',
  templateUrl: './team-base.component.html',
  styleUrls: ['./team-base.component.css']
})
export class TeamBaseComponent implements OnInit {
  content: any;
  orderData: any;
  teamForm: any;
  orderTypeList: any;
  customerBranchList: any;
  orderList: any;
  isNew: Boolean = false;
  addNew: Boolean = false;
  customer_id: any;
  submitted = false;
  teamBaseData: any;
  timeControl = new FormControl();
  companyList: any;
  legacyList: any;
  loading: Boolean;
  teamId: any;

  constructor(
    private orderService: OrderService,
    private customerBranchService: CustomerBranchService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private teamBaseService: TeamBaseService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
     // Lese Team-ID aus Route-Parametern
     // Die Route-Struktur ist: order-disposition/team/:id/team-base
     // TeamBaseComponent ist ein Child von TeamDetailsComponent, daher lesen wir die ID vom Parent
     this.teamId = this.route.parent?.snapshot?.params?.id || this.route.snapshot.params?.id;
     
     console.log('TeamBaseComponent - teamId:', this.teamId);
     console.log('TeamBaseComponent - parent params:', this.route.parent?.snapshot?.params);
     console.log('TeamBaseComponent - current params:', this.route.snapshot.params);
     
     //get current movie data
     this.loading = true;
     
     // Wenn teamId "null" oder null/undefined ist, erstelle ein neues Team
     if (!this.teamId || this.teamId === 'null') {
       this.isNew = true;
       // Lade companyList und legacyList für neues Team
       this.teamBaseService.show('null').subscribe(
         data => {
           this.teamBaseData = data.teamBase || {};
           this.companyList = data.companyList || [];
           this.legacyList = data.legacyList || [];
           this.setForm(this.teamBaseData);
           this.loading = false;
         },
         err => {
           // Falls Fehler, verwende leere Daten
           this.teamBaseData = {};
           this.companyList = [];
           this.legacyList = [];
           this.setForm(this.teamBaseData);
           this.loading = false;
           console.error('Fehler beim Laden der Team-Daten', err);
         }
       );
     } else {
       // Lade bestehendes Team
       this.teamBaseService.show(this.teamId).subscribe(
         data => {
           this.teamBaseData = data.teamBase || {};
           this.companyList = data.companyList || [];
           this.legacyList = data.legacyList || [];
           if (!this.teamBaseData.id) { this.isNew = true; }
           this.setForm(this.teamBaseData);
           this.loading = false;
         },
         err => {
           this.content = JSON.parse(err.error).message;
           this.loading = false;
         }
       );
     }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.teamForm.controls;
  }
  

  setForm(data) {
    this.teamForm = this.fb.group({
      id:                         [data.id],
      label:                      [data.label,Validators.required],
      identity:                   [data.identity,Validators.required],
      phone:                      [data.phone],
      deleted_at:                 [data.deleted_at],
      legacy_team_id:             [data.legacy_team_id],
      color:                      [data.color],
      default_start:              [data.default_start],
      default_end:                [data.default_end],
      killable:                   [data.killable],
      type:                       [data.type || '', Validators.required],  // Tourtyp ist Pflichtfeld (K, M oder S)
      company_id:                 [data.company_id || '']  // Standardwert ist leer
  
    });
  }
  

   prepareChangeListener() {
    this.teamForm.get('customer_id').valueChanges.subscribe(id => {
      this.changeCustomer(id);
    });
   }

   initCustomerBranches() {
      this.changeCustomer(this.teamForm.get('customer_id').value);
   }

   changeCustomer(id) {
    this.customerBranchService.byCustomerId(id).subscribe(
      data => {
        this.teamForm.get('customer_branch_id').value = null;
        this.customerBranchList = data;
      },
      err => {
        this.orderList = JSON.parse(err.error).message;
      }
    );
   }

  submit() {
    this.submitted = true;
    console.log('TeamBaseComponent - submit - form value:', this.teamForm.value);
    console.log('TeamBaseComponent - submit - isNew:', this.isNew);
    if(this.teamForm.valid) { 
      if(this.isNew) {

        //store
        this.teamBaseService.store(this.teamForm.value).subscribe(
          data => {
            this.orderData = data;
            this.toastr.success('Team erfolgreich angelegt!');
            console.log('TeamBaseComponent - Team gespeichert, navigiere zurück');
            // Navigiere zurück zur order-disposition
            // Die Route-Struktur ist: /order/:id/order-disposition/team/null/team-base
            // Wir müssen zurück zu /order/:id/order-disposition navigieren
            const orderId = this.route.snapshot.parent?.parent?.parent?.params?.id;
            if (orderId) {
              this.router.navigate(['/order', orderId, 'order-disposition']).then(() => {
                // Optional: Seite neu laden, um das neue Team anzuzeigen
                window.location.reload();
              });
            } else {
              // Fallback: relative Navigation
              this.router.navigate(['../../..'], { relativeTo: this.route }).then(() => {
                window.location.reload();
              });
            }
          },
          err => {
            console.error('TeamBaseComponent - Fehler beim Speichern:', err);
            this.toastr.warning(err.error?.message || 'Ein Fehler ist aufgetreten', 'Fehler');
          }
        );
      } else {

        //update
        this.teamBaseService.update(this.teamForm.value).subscribe(
          data => {
            this.orderData = data;
            this.toastr.success('Daten gepeichert!');
            // Navigiere zurück zur order-disposition
            const orderId = this.route.snapshot.parent?.parent?.parent?.params?.id;
            if (orderId) {
              this.router.navigate(['/order', orderId, 'order-disposition']);
            } else {
              this.router.navigate(['../../..'], { relativeTo: this.route });
            }
          },
          err => {
            console.error('TeamBaseComponent - Fehler beim Aktualisieren:', err);
            this.toastr.warning(err.error?.message || 'Ein Fehler ist aufgetreten', 'Fehler');
          }
        );
      };
    } else {
      console.log('TeamBaseComponent - Formular ungültig:', this.teamForm.errors);
      this.toastr.warning('Formular nicht korrekt', 'Bitte prüfen');
    }

  }

}
